@use 'sass:color' as sassColor;
@use '../../styling/colors.scss' as *;
@use '../../styling/form-controls.scss' as *;
@use '../../styling/buttons.scss' as *;
@use '../../styling/typography.scss' as *;

$hover-shadow-primary: sassColor.adjust($color-primary-purple, $alpha: -0.8);
$hover-shadow-error: sassColor.adjust($color-primary-red, $alpha: -0.8);

.InputWrapper {
  display: flex;
  flex-direction: column;
  gap: 4px;
  width: 100%;

  .ErrorMessage {
    @extend %form-control-invalid-font;

    border-color: $color-primary-red;
    display: grid;
    grid-template-columns: auto 1fr;
    align-items: center;
    column-gap: 6px;
    padding: 8px 2px;
    font-size: $font-size-normal;

    .ErrorIcon {
      align-self: baseline;
      margin-top: 3px;
    }
  }
}

.SearchInput {
  @extend %form-control-border;
  @extend %form-control-background;

  white-space: nowrap;
  display: flex;
  gap: 4px;
  align-items: center;
  padding: 0 12px 0 16px;
  box-sizing: border-box;
  overflow: hidden;
  height: $button-height;
  width: 100%;

  &.Invalid {
    border-color: $color-primary-red;

    &:hover,
    &:focus-within {
      box-shadow: 0 0 0 3px $hover-shadow-error;
    }
  }

  path {
    fill: $theme-form-alert-info-icon !important; // do not allow overrides
  }

  .ClearButton {
    display: none;

    button {
      display: flex;
      border-radius: 50%;
      background-color: $theme-color-secondary-button-hover;
      color: $theme-color-text;
      padding: 2px;

      path {
        fill: $theme-color-text !important; // do not allow overrides
      }
    }
  }

  &:hover {
    box-shadow: 0 0 0 3px $hover-shadow-primary;
  }

  &:focus-within {
    border-color: $color-primary-purple;
    box-shadow: 0 0 0 3px $theme-hover-focus-shadow;
    z-index: 1;

    .ClearButton {
      display: flex;
    }
  }

  input {
    @extend %form-control-font;

    flex-grow: 1;
    border: none;
    outline: none;
    padding: 0;
    box-sizing: border-box;
    appearance: none;
    width: 100%;
    background-color: $theme-dropdown-background-color;

    &::placeholder {
      color: $theme-placeholder-text;
    }
  }

  &.Disabled {
    background-color: $theme-color-sub-background;
    color: $theme-color-sub-text;

    input {
      background-color: $theme-color-sub-background;
      color: $theme-color-sub-text;
      box-shadow: none;
    }

    input::placeholder {
      color: $theme-placeholder-text;
    }

    &:hover,
    &:focus,
    &:focus-within {
      box-shadow: none;
    }
  }

  .LeadingIcon {
    padding: 2px 4px 0 0;
    display: inline-block;
  }

  &.isLeftBondedInput {
    border-top-right-radius: 0;
    border-bottom-right-radius: 0;
    padding-left: 12px;

    &:hover,
    &:focus-within {
      z-index: 1;
      box-shadow: -1px -2px 0 1px var(--hover-focus-shadow),
        -1px 2px 0 1px var(--hover-focus-shadow),
        -2px 0 0 1px var(--hover-focus-shadow),
        0 0 0 3px var(--hover-focus-shadow);
  }
  }

  &.isRightBondedInput {
    border-left-width: 0;
    border-top-left-radius: 0;
    border-bottom-left-radius: 0;
    padding-left: 12px;

    &:hover,
    &:focus-within {
      border-left-width: 1px;
      box-shadow: 1px -1px 0 2px var(--hover-focus-shadow),
        1px 1px 0 2px var(--hover-focus-shadow),
        0 0 0 0 var(--hover-focus-shadow),
        0 0 0 3px var(--hover-focus-shadow);
    }
  }
}
